export const validateSpaceAddressFields = (fieldName, value, adminUserEmail, currentUserEmail) => {
    // Custom validation logic for each field
    switch (fieldName) {
        case 'zipCode':
            if (value === '') {
                return ['Zipcode is required'];
            }
            return [];
        case 'city':
            if (value === '') {
                return ['City is required'];
            }
            return [];
        case 'stateCode':
            if (value === '') {
                return ['State is required'];
            } 
            // else if (value.toLowerCase() !== 'tx') {
            //     return [
            //         'Sorry, we currently only support listings within Texas. Please choose a location within Texas to create your listing'
            //     ];
            // }
            return [];
        case 'addressOne':
            if (value === '' && adminUserEmail !== currentUserEmail) {
                return ['Street address is required'];
            }
            return [];
        default:
            return [];
    }
};
